export const URLS={
    user:{
        getUserData:"/server/auth/user/getUser",
        login:'/server/auth/user/login',
        logout:'/user/logout',
    }
}